import BASE_URL from "../config";

const json = async (response) => {
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...result };
};

const authHeaders = (token, extra = {}) => ({
  ...extra,
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

/* ---------------------------------------------------------------- public */

export const getConsultationServices = async (category) => {
  const query = category ? `?category=${encodeURIComponent(category)}` : "";
  return json(await fetch(`${BASE_URL}/consultations/services${query}`));
};

export const getConsultationService = async (slug) =>
  json(await fetch(`${BASE_URL}/consultations/services/${encodeURIComponent(slug)}`));

export const getConsultantSlots = async (consultantId, days = 14) =>
  json(await fetch(`${BASE_URL}/consultations/consultants/${consultantId}/slots?days=${days}`));

// Creates a pending booking that holds the slot and returns the PayU form.
export const createConsultationBooking = async (payload, token) =>
  json(
    await fetch(`${BASE_URL}/consultations/bookings`, {
      method: "POST",
      headers: authHeaders(token, { "Content-Type": "application/json" }),
      body: JSON.stringify(payload),
    })
  );

export const getConsultationBooking = async (id) =>
  json(await fetch(`${BASE_URL}/consultations/bookings/${encodeURIComponent(id)}`));

// Hands the browser to PayU's hosted checkout, same as the shop checkout.
export const submitPayuForm = ({ action, params }) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = action;
  Object.entries(params).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value == null ? "" : value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
};

/* ----------------------------------------------------------------- admin */

export const adminGetConsultants = async (token) =>
  json(await fetch(`${BASE_URL}/consultations/admin/consultants`, { headers: authHeaders(token) }));

// `formData` carries the fields plus an optional "photo" file.
export const adminSaveConsultant = async (id, formData, token) =>
  json(
    await fetch(`${BASE_URL}/consultations/admin/consultants${id ? `/${id}` : ""}`, {
      method: id ? "PUT" : "POST",
      headers: authHeaders(token),
      body: formData,
    })
  );

export const adminDeleteConsultant = async (id, token) =>
  json(
    await fetch(`${BASE_URL}/consultations/admin/consultants/${id}`, {
      method: "DELETE",
      headers: authHeaders(token),
    })
  );

export const adminGetConsultationServices = async (token) =>
  json(await fetch(`${BASE_URL}/consultations/admin/services`, { headers: authHeaders(token) }));

// `formData` carries the fields plus an optional "image" file. `id` null creates a new service.
export const adminSaveConsultationService = async (id, formData, token) =>
  json(
    await fetch(`${BASE_URL}/consultations/admin/services${id ? `/${id}` : ""}`, {
      method: id ? "PUT" : "POST",
      headers: authHeaders(token),
      body: formData,
    })
  );

export const adminDeleteConsultationService = async (id, token) =>
  json(
    await fetch(`${BASE_URL}/consultations/admin/services/${id}`, {
      method: "DELETE",
      headers: authHeaders(token),
    })
  );

export const adminGetBookings = async ({ token, page = 1, limit = 20, status = "", search = "" }) => {
  const params = new URLSearchParams({ page, limit });
  if (status) params.append("status", status);
  if (search) params.append("search", search);
  return json(
    await fetch(`${BASE_URL}/consultations/admin/bookings?${params.toString()}`, {
      headers: authHeaders(token),
    })
  );
};

export const adminUpdateBooking = async (id, payload, token) =>
  json(
    await fetch(`${BASE_URL}/consultations/admin/bookings/${id}`, {
      method: "PATCH",
      headers: authHeaders(token, { "Content-Type": "application/json" }),
      body: JSON.stringify(payload),
    })
  );
